import { FlowHead } from '@/shared/ui/Seo/FlowHead'
import { AppLayout } from '@/shared/ui/layouts/AppLayout/index'
import { CoverLayout } from '@/shared/ui/layouts/CoverLayout/index'
import type { ReactNode } from 'react'
import { useOuvidoriaState } from '../state'

type OuvidoriaLayoutProps = {
  children: ReactNode
  variant?: 'app' | 'cover'
  title?: string
  description?: string
}

const defaultTitle = 'Ouvidoria | Flash'
const defaultDescription =
  'A Ouvidoria da Flash avalia casos especiais de atendimento para administradores e colaboradores que precisam de uma devolutiva mais detalhada.'

export function OuvidoriaLayout({
  children,
  variant = 'app',
  title,
  description,
}: OuvidoriaLayoutProps) {
  const { currentStep } = useOuvidoriaState()

  return (
    <>
      <FlowHead
        title={title ?? defaultTitle}
        description={description ?? defaultDescription}
      />
      {variant === 'cover' ? (
        <CoverLayout>{children}</CoverLayout>
      ) : (
        <AppLayout
          steps={['Identificação', 'Mensagem']}
          currentStep={currentStep}
        >
          {children}
        </AppLayout>
      )}
    </>
  )
}
